import * as React from "react";

const CrownIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
  >
    <path
      fill="#F60"
      d="m9.5 4.79-1.285.32-1.605-2a.75.75 0 0 0-1.17 0l-1.605 2-1.31-.32a.755.755 0 0 0-.91.91L2.5 8.81a.5.5 0 0 0 .5.366h6a.5.5 0 0 0 .5-.365l.89-3.11a.755.755 0 0 0-.89-.91M1.375 4.25a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M10.625 4.25a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M6 2.125a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M9 11H3a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1"
    ></path>
  </svg>
);

export default CrownIcon;
